
/**
 * @export
 * @enum {string}
 */
export enum SupportedCurrency {
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP',
    CAD = 'CAD',
    JPY = 'JPY',
    CNY = 'CNY'
}